<template>
  <vis-login-layout>
    <vis-loading size="md" v-if="loading" />
    <vis-error size="md" v-else-if="error" with-default :state="state" />
    <div v-else class="ba-relative ba-w-full md:ba-w-116 ba-mt-15">
      <div
        class="ba-flex ba-justify-center ba-select-none ba-space-x-6 ba-mb-5"
      >
        <router-link
          :to="{ name: 'login', query: { state } }"
          class="ba-text-3xl ba-font-bold ba-text-faint"
        >
          <span>{{ $t('tabs.loginTab') }}</span>
        </router-link>
        <span class="ba-text-3xl ba-font-bold">{{ $t('tabs.registerTab') }}</span>
      </div>
      <p
        v-if="false"
        class="ba-text-center ba-text-sm ba-mb-5"
      >{{ $t('register.registerPerson') }}</p>
      <form
        @submit.prevent="registerFormSubmit"
        class="ba-w-full ba-flex ba-flex-col ba-flex-wrap ba-justify-center ba-relative ba-pt-4"
      >
        <vis-form-messages v-if="formError"
          :form-error-message="$t('register.formError')"
          :form-field-messages="formFieldMessages"
        />
        <p
          v-if="formSuccess"
          class="success form-message ba-text-center ba-text-sm"
        >{{ $t('register.formSuccess') }}</p>
        <p
          v-if="formFieldsRequired"
          class="error form-message ba-text-center ba-text-sm"
        >{{ $t('register.formFieldsRequired') }}</p>
        <p
          v-if="formInvalidEmail"
          class="error form-message ba-text-center ba-text-sm"
        >{{ $t('register.formInvalidEmail') }}</p>
        <p
          v-if="formInvalidComparePassword"
          class="error form-message ba-text-center ba-text-sm"
        >{{ $t('register.formInvalidComparePassword') }}</p>
        <vis-form-input
          v-model="form.firstName"
          :disabled="formLoading"
          :label="$t('register.formFirstName')"
          type="text"
          autocomplete="off"
        />
        <vis-form-input
          v-model="form.lastName"
          :disabled="formLoading"
          :label="$t('register.formLastName')"
          type="text"
          autocomplete="off"
        />
        <vis-form-input
          v-model="form.email"
          :disabled="formLoading"
          :label="$t('register.formEmail')"
          type="text"
          autocomplete="off"
        />
        <vis-form-input
          v-model="form.password"
          :disabled="formLoading"
          :label="$t('register.formPasswd')"
          type="password"
          autocomplete="off"
        />
        <vis-form-input
          v-model="form.repeatPassword"
          :disabled="formLoading"
          :label="$t('register.formRepeatPasswd')"
          type="password"
          autocomplete="off"
        />
        <vis-captcha v-if="showCaptcha && captchaEnabled" :result.sync="captchResult" :refresh.sync="refreshCaptcha" />
        <button
          type="submit"
          :disabled="formLoading"
          class="ap-button btn ba-w-full ba-max-w-xs btn--login ba-mt-6 ba-mx-auto"
        >{{ $t('button.register') }}</button>
      </form>
      <a
        v-if="false"
        target="_blank"
        href="https://domain/privacy/privacy-policy"
        class="ba-w-full ba-block ba-text-center ba-text-sm ba-underline hover:ba-no-underline"
      >{{ $t('privacyPolicy') }}</a>
      <a
        v-if="false"
        target="_blank"
        href="https://domain/privacy/user-agreement"
        class="ba-w-full ba-block ba-text-center ba-text-sm ba-underline hover:ba-no-underline"
      >{{ $t('userAgreement') }}</a>
    </div>
  </vis-login-layout>
</template>

<script>
import VisLoginLayout from "./vis-login-layout";
import VisCaptcha from "./vis-captcha";
import { registerMixin } from "@ba/visary-account-common-vue";
import formMessagesMixin from "@/mixins/form-messages-mixin";

export default {
  name: "vis-page-register",
  components: {
    VisLoginLayout,
    VisCaptcha
  },
  mixins: [registerMixin, formMessagesMixin],
  data() {
    return {
      captchaEnabled: false
    };
  },
  computed: {
    formMessages() {
      return {
        BadRequest: {
          password: {
            MinLength: this.passwordMinLength,
            MinCapitalLetters: this.passwordMinCapitalLetters,
            MinCursiveLetters: this.passwordMinCursiveLetters,
            MinDigits: this.passwordMinDigits,
            MinSpecialCharacters: this.passwordMinSpecialCharacters,
            MaxLength: this.passwordMaxLength
          }
        }
      }
    }
  },
  watch: {
    registerInfo() {
      if (!this.registerInfo?.canRegister) {
        this.$router.replace({ name: "login", query: { state: this.state } });
      }
    }
  }
};
</script>
